import styled from 'styled-components/macro';

export const MapWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100vw;
  margin: ${({ theme }): string => `${theme.spacing.medium} 0`};
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  @media screen and (orientation: landscape) {
    height: 100vh;
  }

  @media screen and (min-width: 640px) {
    height: 60vh;
  }
`;
